export const refresh_url =
  "https://apiv2.invoxcontact.com/auth/refresh/InvoxAPI";

export const login_auth2_url =
  "https://apiv2.invoxcontact.com/auth/auth.s2/InvoxAPI";

export const X_API_KEY = "c0rn05wuqo8F8AspQ5mtD5NaPyJ8SIcQ8gUbhovV";
export const ID_TOKEN = "idToken";
export const TOKEN_TYPE = "tokenType";
export const EXTRA_TOKEN = "extraToken";
export const REFRESH_TOKEN = "refreshToken";
export const EXPIRE = "expire";

/* Keycloack */

export const AUTHORIZATION_URL = "https://apiv2.invoxcontact.com/auth/authorization/InvoxAPI";

export const LOGOUT_URL = "/protocol/openid-connect/logout";

export const GO_VERSION_WA = "goVersionWA";
export const GO_VERSION_WP = "goVersionWP";
export const ISSUER = "iss";



// WEBPACK FOOTER //
// ./src/utils/constants.js